export const NODE_ENV = process.env.NODE_ENV;
export const isDev = NODE_ENV === 'development';

export const API_URL = process.env.API_URL;
export const UPLOAD_URL = process.env.UPLOAD_URL;
export const WEBSITE_URL = process.env.WEBSITE_URL;
export const PAYPAL_KEY = process.env.PAYPAL_KEY;
export const ADYEN_KEY = process.env.ADYEN_KEY;
export const CONTENT_TEAM_MODE = String(process.env.CONTENT_TEAM_MODE) === 'true';
export const TEMPLATE_LIST_URL = process.env.TEMPLATE_LIST_URL;
export const TRANSITIONS_URL = process.env.TRANSITIONS_URL;
export const ZEN_DESK_API_KEY = process.env.ZEN_DESK_API_KEY;
export const REACT_APP_API_URL = process.env.REACT_APP_API_URL; // PhotoSidebar uses it internally
export const FRONTEND_VERSION = process.env.FRONTEND_VERSION; // hash of last commit
export const RC_VERSION = process.env.RC_VERSION;
export const BUGSNAG_API_KEY = process.env.BUGSNAG_API_KEY;
export const LOCALIZATION_TEAM_MODE = JSON.parse(process.env.LOCALIZATION_TEAM_MODE);
export const REACT_APP_RECAPTCHA_PUBLIC_KEY = process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY; // Monetization uses it internally
